<script setup lang="ts">
import { useClipboard } from '@vueuse/core'
import { BasicButton, Element, colors } from 'wepin-vue-component'
import { useI18nTypes } from '@/composables'
import type { Address } from '@/types'

const props = withDefaults(
  defineProps<{
    onlyCopy?: boolean
    address: Address
    modal: boolean
  }>(),
  {
    onlyCopy: false,
  },
)
const emits = defineEmits<{
  (event: 'open-modal'): void
}>()
const { t } = useI18nTypes()
const { copy } = useClipboard({
  legacy: true,
})
const onClickCopy = () => {
  if (props.modal) return
  copy(props.address.toString())
  emits('open-modal')
}
</script>

<template>
  <div v-if="!onlyCopy" class="address-copy-viewer">
    <span class="address-text">
      {{ address }}
    </span>
    <BasicButton class="btn-copy" type="small_outlined" @click="onClickCopy">
      <Element
        name="Copy"
        size="small"
        :color="colors.currentThemeRef.value.grey_111"
      />
      <span>{{ t('receive.copy') }}</span>
    </BasicButton>
  </div>
  <Element
    v-else
    class="pointer"
    name="Copy"
    size="small"
    :color="colors.currentThemeRef.value.grey_111"
    @click="onClickCopy"
  />
</template>

<style lang="scss" scoped>
@import 'wepin-vue-component/src/styles/typeface.module.scss';

.address-copy-viewer {
  display: flex;
  flex-flow: column;
  justify-content: center;
  align-items: center;
  padding: 20px;
  border-style: solid;
  border-width: 1px;
  border-color: var(--line_02);
  border-radius: 8px;
  margin: {
    top: 20px;
  }

  .address-text {
    @include typeface('Paragraph_14_r');
    word-break: break-all;
    text-align: center;
  }
  .btn-copy {
    margin-top: 15px;
  }
}

.pointer {
  cursor: pointer;
}
</style>
